import {getGeocodeCloudFlarePoP, suggestCountryDomain, MissingCountryDomainError} from './geocode.js';
const {__} = window.wp.i18n;

const alpha2ccI18NCountryNameMap = {
  // translators: Used in the main sentence of suggested country URL banner. "We think you are in <country name> ..."
  US: __('the United States', 'ae'),
  GB: __('the United Kingdom', 'ae'),
  MX: __('Mexico', 'ae'),
  IT: __('Italy', 'ae'),
  IN: __('India', 'ae'),
  ES: __('Spain', 'ae'),
  DE: __('Germany', 'ae'),
  BR: __('Brazil', 'ae')
};

// * Could switch to a more robust dependency https://github.com/js-cookie/js-cookie
function setCookie(name, value, expireDays) {
  const d = new Date();
  d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value}; expires=${d.toUTCString()}; path=/; SameSite=Strict;`;
}

function getCookie(name) {
  name = name + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

//* https://stackoverflow.com/a/8526477 Inversion of control principle for testing
//* https://stackoverflow.com/a/45961549 jsdom setup for testing key elements
export async function handleSuggestCountryURLBanner() {
  try {
    const {country: alpha2CC} = await getGeocodeCloudFlarePoP();
    const suggestedDomain = suggestCountryDomain(alpha2CC,
      typeof alpha2CountryCodeDomainMapFromWP === 'undefined' ? {} : alpha2CountryCodeDomainMapFromWP);
    const cookieName = 'ignoreSuggestedCountryURLBanner';
    const shouldShowBanner =
      suggestedDomain !== window.location.hostname && !getCookie(cookieName);
    if (shouldShowBanner) {
      const bannerEle = document.getElementById('suggested-animal-equality-domain-banner');

      if (!bannerEle) {
        return;
      }

      const suggestedURLEle = bannerEle.querySelector('#suggested-url');
      const countryNameEle = bannerEle.querySelector('#country-name');
      const countryCodeEle = bannerEle.querySelector('#alpha2-country-code');
      const countryName = alpha2ccI18NCountryNameMap[alpha2CC];

      if (countryCodeEle) {
        bannerEle.querySelector('#alpha2-country-code').textContent = alpha2CC === 'GB' ? 'UK' : alpha2CC;
      }

      if (suggestedURLEle) {
        suggestedURLEle.setAttribute('href', `https://${suggestedDomain}`);
      }

      if (countryNameEle) {
        countryNameEle.textContent = countryName;
      }

      bannerEle.querySelector('#stay-here').addEventListener('click', () => {
        bannerEle.style.display = 'none';
      });

      setCookie(cookieName, true, 7);
      bannerEle.style.display = 'flex';
    }
  } catch(error) {
    if (error instanceof MissingCountryDomainError) {
      // Ignore MissingCountryDomainError
      return;
    }
    console.error(error);
  }
}

export const _testing = {
  setCookie,
  getCookie
};
